package com.checkin.host.ui.profile

import androidx.compose.runtime.*
import com.checkin.host.api.ApiClient
import com.checkin.host.api.ApiException
import com.checkin.host.theme.cardStyle
import com.checkin.host.theme.primaryButton
import com.checkin.host.theme.secondaryButton
import com.checkin.host.ui.components.TextField
import com.checkin.host.ui.layout.AlertBanner
import com.checkin.host.ui.layout.PageHeader
import com.checkin.host.ui.layout.rememberIsMobile
import com.checkin.shared.dto.UpdateProfileRequest
import com.checkin.shared.dto.UserDto
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ProfileScreen(user: UserDto, onUserUpdated: (UserDto) -> Unit) {
    var displayName by remember(user) { mutableStateOf(user.displayName) }
    var message by remember { mutableStateOf<String?>(null) }
    var isError by remember { mutableStateOf(false) }
    var loading by remember { mutableStateOf(false) }
    var passwordLoading by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()

    PageHeader("Profil", "Compte et connexion")

    message?.let { AlertBanner(it, isError) }

    val isMobile = rememberIsMobile()
    Div({
        style {
            cardStyle()
            property("max-width", if (isMobile) "100%" else "480px")
        }
    }) {
        H3({ style { marginTop(0.px) } }) { Text("Informations") }
        Div({ style { marginBottom(12.px) } }) { TextField("Nom affiché", displayName) { displayName = it } }
        Div({ style { marginBottom(20.px) } }) {
            TextField("Email (identifiant de connexion)", user.email, InputType.Email, readOnly = true)
        }
        Div({
            style {
                display(DisplayStyle.Flex)
                flexWrap(FlexWrap.Wrap)
                alignItems(AlignItems.Center)
                gap(12.px)
                marginTop(4.px)
            }
        }) {
            Button({
                style { primaryButton() }
                onClick {
                    scope.launch {
                        loading = true
                        message = null
                        try {
                            val updated = ApiClient.updateProfile(
                                UpdateProfileRequest(displayName = displayName.trim()),
                            )
                            ApiClient.saveUser(updated)
                            onUserUpdated(updated)
                            message = "Profil mis à jour"
                            isError = false
                        } catch (e: ApiException) {
                            message = e.message
                            isError = true
                        } finally {
                            loading = false
                        }
                    }
                }
            }) { Text(if (loading) "..." else "Enregistrer") }
            if (user.hasPassword) {
                Button({
                    style { secondaryButton() }
                    onClick {
                        scope.launch {
                            passwordLoading = true
                            message = null
                            try {
                                ApiClient.forgotPassword(user.email)
                                message = "Un email de réinitialisation vient d'être envoyé à ${user.email}."
                                isError = false
                            } catch (e: ApiException) {
                                message = e.message
                                isError = true
                            } finally {
                                passwordLoading = false
                            }
                        }
                    }
                }) { Text(if (passwordLoading) "..." else "Changer le mot de passe") }
            }
        }
    }
}
